require('../../modules/es.string.repeat');

module.exports = require('../../internals/entry-unbind')('String', 'repeat');



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/es/string/repeat.js
// module id = 549
// module chunks = 0